import { Controller } from "@hotwired/stimulus"

// MC-1944: swaps the worker version form's model select when the LLM vendor
// select changes. On change it points the model Turbo Frame at the
// `model_fields` endpoint for the newly chosen vendor; Turbo fetches and
// replaces just that frame, so the model choices always match the vendor while
// the rest of the form is left untouched. Mirrors
// inbound_action_select_controller. Progressive: with no JS the form still
// submits and the server renders the submitted vendor's models.
//
// MC-1915: the model select reuses it with `param` set to "model", pointing
// the nested effort frame at `effort_fields` for the newly chosen model.
export default class extends Controller {
  static values = {
    url: String,
    frame: String,
    param: { type: String, default: "llm_vendor" }
  }

  reload() {
    const frame = document.getElementById(this.frameValue)
    if (!frame) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set(this.paramValue, this.element.value)
    frame.setAttribute("src", url.pathname + url.search)
  }
}
